import auth from '@/middleware/auth'
import { PERMISSION_LEVELS } from '@/constants/permissions'

export default [
	{
		path: '/profile',
		name: 'Profile',
		icon: 'profile',
		meta: {
			title: 'menu.profile',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/profile/Personal')
	},
	{
		path: '/profile/password',
		name: 'Security',
		icon: 'roles',
		meta: {
			title: 'menu.security',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/profile/Password')
	},
	{
		path: '/profile/preferences',
		name: 'Preferences',
		icon: 'settings',
		meta: {
			title: 'menu.preferences',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/profile/Settings')
	},
	{
		path: '/profile/integrations',
		name: 'Integrations',
		icon: 'settings',
		meta: {
			title: 'menu.integrations',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/profile/Integracoes')
	}
]
